import { Icon } from './components/Icon.jsx';

export const SECTIONS = [
  { id: 'name', label: 'Bot Name & Greeting', icon: Icon.bot },
  { id: 'model', label: 'Model & AI', icon: Icon.spark },
  { id: 'tone', label: 'Tone', icon: Icon.msg },
  { id: 'language', label: 'Language', icon: Icon.globe },
  { id: 'personality', label: 'Personality & Instructions', icon: Icon.spark },
  { id: 'fallback', label: 'Fallback Message', icon: Icon.life },
  { id: 'handoff', label: 'Human-Handoff & Escalation', icon: Icon.msg },
  { id: 'lead-capture', label: 'Lead capture', icon: Icon.msg },
  { id: 'prohibited', label: 'Prohibited Topics', icon: Icon.alert },
  { id: 'response-boundary', label: 'Response Boundary', icon: Icon.alert },
  { id: 'responsive-settings', label: 'Responsive Settings', icon: Icon.globe },
  { id: 'response-style', label: 'Response Style', icon: Icon.msg },
];

export const TONES = [
  { id: 'friendly', name: 'Friendly', example: "Hey there! Happy to help you figure this out \u{1F60A}" },
  { id: 'professional', name: 'Professional', example: "Thank you for reaching out. I'd be glad to assist." },
  { id: 'casual', name: 'Casual', example: "Sure thing — let's sort this out for you." },
  { id: 'empathetic', name: 'Empathetic', example: "I understand that's frustrating — let's fix it together." },
  { id: 'formal', name: 'Formal', example: 'We appreciate your inquiry and will address it promptly.' },
];

// Checklist §3 requires "Unicode/RTL language names render correctly
// (FR-NFR Localization)". Each language carries its own native-script
// name (and an `rtl` flag for Arabic) so the Language panel actually
// renders real Unicode/RTL text instead of English labels standing in
// for every language.
export const ALL_LANGUAGES = [
  { code: 'en', name: 'English', native: 'English' },
  { code: 'hi', name: 'Hindi', native: 'हिन्दी' },
  { code: 'te', name: 'Telugu', native: 'తెలుగు' },
  { code: 'ta', name: 'Tamil', native: 'தமிழ்' },
  { code: 'es', name: 'Spanish', native: 'Español' },
  { code: 'fr', name: 'French', native: 'Français' },
  { code: 'de', name: 'German', native: 'Deutsch' },
  { code: 'ar', name: 'Arabic', native: 'العربية', rtl: true },
  { code: 'pt', name: 'Portuguese', native: 'Português' },
];

// DEMO/MOCK DATA: in production this would come from the Knowledge Base
// API (which languages currently have published KB content). Hard-coded
// here only so the "removing a supported language that has published
// knowledge in it" confirmation (checklist §3) is exercisable in this
// frontend-only prototype. Replace with a real KB lookup at integration.
export const LANGUAGES_WITH_PUBLISHED_KNOWLEDGE = ['hi', 'te'];
